/*
	ODIN ENTERPRISE MANAGER
	CREATED BY - UP ADVERTISING TEAM - TECH LEAD: GYENES PÉTER (peter.gyenes@up.hu, info@up.hu)
	VUE JS 1.0 - JQUERY - LARAVEL BACKEND
 */
console.log('                             .:|###+|,');
console.log('                        |#################,|');
console.log('                     |#######################:|');
console.log('                   :############################');
console.log('                 :################################');
console.log('                ###################################:');
console.log('              |######################################');
console.log('             ###############| ####### |###############|');
console.log('            ###############|  #######   ###############|');
console.log('          |################ : ####### | +###############|');
console.log('          ################# #  #####  | ,################+');
console.log('         ################## #   ###   | ,#################|');
console.log('        ################### # # ### | | ,##################.');
console.log('       ###################  # # ### | |  |##################');
console.log('      |##################   # # ### | | | ###################');
console.log('      ################### # # # ### | | : ,##################+');
console.log('     #################### # # # ### | | : .###################');
console.log('    :#################### # # # ### | | : .####################');
console.log('    ####################| #:# # ### | |#:  ####################|');
console.log('   :###################,  ### # ### | |##   ####################');
console.log('   #################### + ### # ### | |## . |###################');
console.log('  |#################### # ### # # # | |## . |####################');
console.log('  ##################### ##### # ### | |###.  ####################');
console.log('  ##################### ####|         ,####  ####################.');
console.log(' |##################### ##.   , ### ||   ##  #####################');
console.log(' ###################### #  |##+ # + :###  #  #####################');
console.log(' ######################   ####  # +| ####|   #####################');
console.log(' ######################  ##### |# +# +####   #####################.');
console.log(' ###################### |####  ## +#| ####+  #####################|');
console.log('.###################### ####  ### +##  ####  ######################');
console.log(':#######  :###   ###### ##.  #### +###   ##  ##### ###|#.:#########');
console.log('|###### +# ### #| #####                      ##### ### #.:#########');
console.log('+###### ## ### ## ##### :::::::::::::::::::  ##### ### |.:#########');
console.log('####### ## ### ## ##### ###################  ##### ###  .:#########');
console.log('####### ## ### ## #####         ###          ##### ### :.:#########');
console.log('+###### ## ### ## ############# ### |############# ### # :#########');
console.log('|###### |# ### #:|##### ## |+ # ### |++++##  ##### ### # :#########');
console.log(',#######  |###  |###### ###  |# ### |    ##  ##### ### #+:#########');
console.log(' ###################### ##+  |# ### |######  ######################');
console.log(' ###################### #+ |# # ### |######  #####################,');
console.log(' ######################  #|#### ### |#####:  #####################');
console.log(' ######################   ##### |#+ |####:   #####################');
console.log(' ,##################### # ####|+ | .|#### .  #####################');
console.log('  ##################### # ###  ## .#  ### .  ####################:');
console.log('  ##################### # ##  #  +| +  ## .  ####################');
console.log('  :#################### # #  #  ###, +  # .  ####################');
console.log('   #################### # # #  #   |, + , .  ###################.');
console.log('   +################### # # # # . . | | , .  ###################');
console.log('    ################### # # # # # # | | , .  ##################:');
console.log('    ###################   # # # # # | | ,   |##################');
console.log('     ###################  # # # # # | | ,  |##################.');
console.log('     :###################   # # # # | |   |###################');
console.log('      ####################  # # # # | |  |###################');
console.log('       ####################   # # # | | |###################,');
console.log('       |####################  # # # |  |###################+');
console.log('        :####################   # # | |####################');
console.log('         |####################  # #  |####################');
console.log('          |####################   . |####################');
console.log('           |####################   |####################');
console.log('            .#################### |###################+');
console.log('              #######################################,');
console.log('               |####################################');
console.log('                 #################################.');
console.log('                  |#############################|');
console.log('                     #########################.');
console.log('                       .###################:');
console.log('                           .|##########|');

/*
console.log('%c Oh my heavens! ', 'background: #222; color: #bada55');
 */

var token;
var baseURL;
var activeInstance;
var headerProfileInstance;
var topBarInstance;
var vueInstance;
var activeCategory;
var productId;
var run_mode;
var dropzoneinstance;
var loader_image = baseURL+'/img/loader_103_256.gif';

$('.admin_panel_icon').click(function(){

    if( $('.user_profile_menu').hasClass('visible') ){
        $('.user_profile_menu').toggleClass('visible');
    }

    $('.admin_panel').toggleClass('visible');
});

$('body').on('click','.user_profile',null,function(){

    if( $('.admin_panel').hasClass('visible') ){
        $('.admin_panel').toggleClass('visible');
    }

    $('.user_profile_menu').toggleClass('visible');

});
